module.exports = __webpack_public_path__ + "img/bspoke.c167155b.png";